import React, { useState } from "react";
import { Link } from "react-router-dom"; // Importamos Link de react-router-dom
import SubUniversalMenuMobile from "./components/SubUniversalMenuMobile";

export default function HomeHeader({
  nombrePaginaSeleccionada = "",
  mActivar_DesactivarModal = () => {},
}) {
  const [menuOpen, setMenuOpen] = useState(false); // Estado para manejar la visibilidad del menú

  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Alternar el estado del menú, lo niega y, de esa forma se almacena el valor opuesto
  };

  return (
    <div data-figma-id="113:9429" className="menu-publico">
      <SubUniversalMenuMobile
        nombrePaginaSeleccionada={nombrePaginaSeleccionada}
        menuOpen={menuOpen}
        toggleMenu={toggleMenu}
      />

      <i class="fi fi-ss-menu-burger menu-burger-3" onClick={toggleMenu}></i>

      <Link to="/" className="apartado-menu-texto">
        <img
          src={`${window.location.origin}/images/logo.png`}
          data-figma-id="113:9430"
          className="img"
          alt="Logo"
        />
      </Link>

      <div data-figma-id="113:9431" className="menu-publico-apartados">
        {/* Link para Home */}
        <Link
          to="/"
          data-figma-id="113:9512"
          className={`apartado-menu${
            nombrePaginaSeleccionada === "Home" ? "" : "-2"
          }`}
        >
          <div className="apartado-menu-texto">Home</div>
        </Link>

        {/* Cursos (Deja esto como está si no tiene ruta) */}
        <Link
          to="/cursos"
          data-figma-id="113:9514"
          className={`apartado-menu${
            nombrePaginaSeleccionada === "Cursos" ? "" : "-2"
          }`}
        >
          <div className="apartado-menu-texto">Cursos</div>
        </Link>

        {/* Link para Nosotros */}
        <Link
          to="/nosotros"
          data-figma-id="113:9516"
          className={`apartado-menu${
            nombrePaginaSeleccionada === "Nosotros" ? "" : "-2"
          }`}
        >
          <div className="apartado-menu-texto">Nosotros</div>
        </Link>
      </div>

      <div data-figma-id="113:9435" className="menu-publico-botones">
        <div
          data-figma-id="113:9496"
          className="boton-login-home"
          onClick={() => mActivar_DesactivarModal("login", true)}
        >
          <p data-figma-id="113:9497" className="boton-login-home-texto">
            Inicia Sesión
          </p>
        </div>

        <div
          className="icono-login"
          onClick={() => mActivar_DesactivarModal("login", true)}
        >
          <div className="user-1-1">
            <i class="fi fi-sr-user vectors-wrapper"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
